import { CQ_ACTION_CODES, CQ_POTS } from '../../../catalogConstants';
import { STRING_KEYS } from '../../common';
import { USER_TYPE } from '../../../bitConstants/constants';

export const localizedStrings = {
  common: {
    everyMainSelection: {
      [STRING_KEYS.se.order.subject]: 'TELCOBI DUO Error TELCO',
      [STRING_KEYS.se.risk.subject]: 'TELCOBI DUO Riesgo Error 800',
      [STRING_KEYS.process.title]: '',
      [STRING_KEYS.installation.text]: '',
      [STRING_KEYS.provisionalAgreement.title]: '',
      [STRING_KEYS.provisionalAgreement.pdfLinkText]: 'Descarga del resumen del contrato (PDF).',
      [STRING_KEYS.landLineSecondaryAction.subTitle]: 'Configuración número fijo',
      [STRING_KEYS.payment.step.insertDirectDebit]: '',
      [STRING_KEYS.summary.title]: '',
      [STRING_KEYS.summary.mandatoryFieldsModal.title]: 'Campos obligatorios',
      [STRING_KEYS.summary.mandatoryFieldsModal.subTitle]: 'Por favor revisa el formulario, hay campos obligatorios sin completar.',
      [STRING_KEYS.summary.additionalMobileLineAction.title]: 'Línea móvil',
      [STRING_KEYS.summary.shipment.title]: 'Envío SIMs',
      [STRING_KEYS.summary.shipment.text]: 'Recibirás la tarjeta SIM en un plazo de 48h.',
      [STRING_KEYS.summary.shipment.secondaryText]: '',
      [STRING_KEYS.summary.landLineAction.title]: 'Línea fija',
      [STRING_KEYS.summary.productBarInfo.additionalInfoText]: 'Dirección',
      [STRING_KEYS.se.message.shoppingCart.title]: 'INFORMACION VENTA DE PRODUCTOS',
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.TELCO}`]: {
    everyMainSelection: {
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.OPEN}`]: {
    everyMainSelection: {
      [STRING_KEYS.shipment.new]: '',
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  selfEmployed: {
    everyMainSelection: {},
  },
};
